import { render } from "./rep023.vue?vue&type=template&id=08648a39&scoped=true"
import script from "./rep023.vue?vue&type=script&lang=js"
export * from "./rep023.vue?vue&type=script&lang=js"

import "./rep023.vue?vue&type=style&index=0&id=08648a39&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08648a39"]])

export default __exports__